module.exports = __webpack_public_path__ + "img/Covid-Banner-1080x200.1dddcadd.jpg";